import React from "react";
// Data Block page

// Default
import { useState } from "react";
import { Handle, Position } from "@xyflow/react";

// Custom
import CustomInput from "../../forms/input/Input";

// Mui
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

const DataBlock = ({
  data,
  id,
  onChange,
}: {
  data: any;
  id: string;
  onChange: (id: string, data: any) => void;
}) => {
  const [nodeName, setNodeName] = useState(data.name || "View Data Block");
  const [isEditingName, setIsEditingName] = useState(false);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNodeName(e.target.value);
  };

  const handleNameBlur = () => {
    setIsEditingName(false);
    onChange(id, { ...data, name: nodeName }); // Update the parent with the new name
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    try {
      const parsed = JSON.parse(value);
      onChange(id, { ...data, jsonData: parsed }); // Notify parent of valid JSON updates
    } catch {
      // Ignore invalid JSON input
    }
  };

  return (
    <Card
      sx={{
        width: "170px",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
        backgroundColor: "#FFFFFF",
        minHeight: "80px",
        display: "flex",
        flexDirection: "column",
      }}>
      {/* Header */}
      <Box
        sx={{
          textAlign: "center",
          padding: "5px",
          background: "linear-gradient(180deg, #43E97B 0%, #38D39F 100%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        {isEditingName ? (
          <CustomInput
            value={nodeName}
            onChange={handleNameChange}
            onBlur={handleNameBlur}
          />
        ) : (
          <Box onClick={() => setIsEditingName(true)}>
            <Typography
              variant="body1"
              color="#FFFFFF"
              fontWeight={600}
              fontSize={"12px"}>
              {nodeName}
            </Typography>
          </Box>
        )}
      </Box>

      {/* Content */}
      <Stack
        padding={"5px"}
        sx={{
          backgroundColor: "#FFFFFF",
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <CustomInput
          value={JSON.stringify(data.jsonData || {}, null, 2)}
          onChange={handleInputChange}
          multiline={true}
          rows={3}
          placeholder="Enter JSON here..."
          sx={{
            fontSize: "9px",
          }}
        />
      </Stack>

      {/* Handles */}
      <Handle
        type="target"
        position={Position.Left}
        style={{
          background: "#555",
          borderRadius: "50%",
          height: "10px",
          width: "10px",
        }}
      />
      {/* Output Connector */}
      <Handle
        type="source"
        position={Position.Right}
        style={{
          background: "#555",
          borderRadius: "50%",
          height: "10px",
          width: "10px",
        }}
      />
    </Card>
  );
};

export default DataBlock;
